/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { AppRoutes } from "../routes/routes"

export function forceLoginRedirect(): void {
    window.location.href = AppRoutes.Login
}

export function forceHomeRedirect(): void {
    window.location.href = AppRoutes.Home
}

export function forceRedirect404(): void {
    window.location.href = AppRoutes.PageNotFound
}
